/*

	Format a date according to https://www.php.net/manual/function.strftime.php

	Implemented:

		Day
		%a  -  An abbreviated textual representation of the day  -  Sun through Sat
		%A  -  A full textual representation of the day  -  Sunday through Saturday
		%d  -  Two-digit day of the month (with leading zeros)  -  01 to 31
		%e  -  Day of the month, with a space preceding single digits  -  1 to 31
		%u  -  ISO-8601 numeric representation of the day of the week  -  1 (for Monday) though 7 (for Sunday)
		%w  -  Numeric representation of the day of the week  -  0 (for Sunday) through 6 (for Saturday)

		Month
		%b  -  Abbreviated month name, based on the locale  -  Jan through Dec
		%B  -  Full month name, based on the locale  -  January through December
		%h  -  Abbreviated month name, based on the locale (an alias of %b)  -  Jan through Dec
		%m  -  Two digit representation of the month  -  01 (for January) through 12 (for December)

		Year
		%C  -  Two digit representation of the century (year divided by 100, truncated to an integer)  -  19 for the 20th Century
		%y  -  Two digit representation of the year  -  Example: 09 for 2009, 79 for 1979
		%Y  -  Four digit representation for the year  -  Example: 2038

		Time
		%H  -  Two digit representation of the hour in 24-hour format  -  00 through 23
		%k  -  Two digit representation of the hour in 24-hour format, with a space preceding single digits  -  0 through 23
		%I  -  Two digit representation of the hour in 12-hour format  -  01 through 12
		%l (lower-case 'L')  -  Hour in 12-hour format, with a space preceding single digits  -  1 through 12
		%M  -  Two digit representation of the minute  -  00 through 59
		%p  -  UPPER-CASE 'AM' or 'PM' based on the given time  -  Example: AM for 00:31, PM for 22:23
		%P  -  lower-case 'am' or 'pm' based on the given time  -  Example: am for 00:31, pm for 22:23
		%r  -  Same as "%I:%M:%S %p"  -  Example: 09:34:17 PM for 21:34:17
		%R  -  Same as "%H:%M"  -  Example: 00:35 for 12:35 AM, 16:44 for 4:44 PM
		%S  -  Two digit representation of the second  -  00 through 59
		%T  -  Same as "%H:%M:%S"  -  Example: 21:34:17 for 09:34:17 PM
		%z  -  The time zone offset  -  Example: -0500 for US Eastern Time

		Time and Date Stamps
		%D  -  Same as "%m/%d/%y"  -  Example: 02/05/09 for February 5, 2009
		%F  -  Same as "%Y-%m-%d" (commonly used in database datestamps)  -  Example: 2009-02-05 for February 5, 2009
		%s  -  Unix Epoch Time timestamp (same as the time() function)  -  Example: 305815200 for September 10, 1979 08:40:00 AM

		Miscellaneous
		%n  -  A newline character ("\n")
		%t  -  A Tab character ("\t")
		%%  -  A literal percentage character ("%")

	Not implemented:

		Day
		%j  -  Day of the year, 3 digits with leading zeros  -  001 to 366

		Week
		%U  -  Week number of the given year, starting with the first Sunday as the first week  -  13 (for the 13th full week of the year)
		%V  -  ISO-8601:1988 week number of the given year, starting with the first week of the year with at least 4 weekdays, with Monday being the start of the week  -  01 through 53 (where 53 accounts for an overlapping week)
		%W  -  A numeric representation of the week of the year, starting with the first Monday as the first week  -  46 (for the 46th week of the year beginning with a Monday)

		Year
		%g  -  Two digit representation of the year going by ISO-8601:1988 standards (see %V)  -  Example: 09 for the week of January 6, 2009
		%G  -  The full four-digit version of %g  -  Example: 2008 for the week of January 3, 2009

		Time
		%X  -  Preferred time representation based on locale, without the date  -  Example: 03:59:16 or 15:59:16
		%Z  -  The time zone abbreviation  -  Example: EST for Eastern Time

		Time and Date Stamps
		%c  -  Preferred date and time stamp based on locale  -  Example: Tue Feb 5 00:45:10 2009 for February 5, 2009 at 12:45:10 AM
		%x  -  Preferred date representation based on locale, without the time  -  Example: 02/05/09 for February 5, 2009

*/

/**
 * Format a date according to https://www.php.net/manual/function.strftime.php
 * @param    {string}  format  Format to apply to date
 * @returns  {string}          Date formatted according to the format
 */
Date.prototype.strftime = function (format)
{
	var output = '';
	while (format != '')
	{
		// Getting position of % char
		pos = format.indexOf('%');
		if (pos < 0) pos = format.length;

		// Splitting data
		output += format.substring(0, pos);  // Adding to output
		digit = format.substring(pos, pos + 2);  // Getting digit
		format = format.substring(pos + 2);  // Updating input

		// Switching
		switch (digit)
		{
			// Day
			case '%a':  // %a  -  An abbreviated textual representation of the day  -  Sun through Sat

				output += ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][this.getDay()];
				break;

			case '%A':  // %A  -  A full textual representation of the day  -  Sunday through Saturday

				output += ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][this.getDay()];
				break;

			case '%d':  // %d  -  Two-digit day of the month (with leading zeros)  -  01 to 31

				output += this.getDate().toString().lpad('0', 2);
				break;

			case '%e':  // %e  -  Day of the month, with a space preceding single digits  -  1 to 31

				output += this.getDate().toString().lpad(' ', 2);
				break;

			// %j  -  Day of the year, 3 digits with leading zeros  -  001 to 366

			case '%u':  // %u  -  ISO-8601 numeric representation of the day of the week  -  1 (for Monday) though 7 (for Sunday)

				var day = this.getDay();
				output += day ? day : 7;
				break;

			case '%w':  // %w  -  Numeric representation of the day of the week  -  0 (for Sunday) through 6 (for Saturday)

				output += this.getDay();
				break;

			// Week
			// %U  -  Week number of the given year, starting with the first Sunday as the first week  -  13 (for the 13th full week of the year)
			// %V  -  ISO-8601:1988 week number of the given year, starting with the first week of the year with at least 4 weekdays, with Monday being the start of the week  -  01 through 53 (where 53 accounts for an overlapping week)
			// %W  -  A numeric representation of the week of the year, starting with the first Monday as the first week  -  46 (for the 46th week of the year beginning with a Monday)

			// Month
			case '%b':  // %b  -  Abbreviated month name, based on the locale  -  Jan through Dec
			case '%h':  // %h  -  Abbreviated month name, based on the locale (an alias of %b)  -  Jan through Dec

				output += ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'][this.getMonth()];
				break;

			case '%B':  // %B  -  Full month name, based on the locale  -  January through December

				output += ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'][this.getMonth()];
				break;

			case '%m':  // %m  -  Two digit representation of the month  -  01 (for January) through 12 (for December)

				output += (this.getMonth() + 1).toString().lpad('0', 2);
				break;

			// Year
			// %g  -  Two digit representation of the year going by ISO-8601:1988 standards (see %V)  -  Example: 09 for the week of January 6, 2009
			// %G  -  The full four-digit version of %g  -  Example: 2008 for the week of January 3, 2009

			case '%C':  // %C  -  Two digit representation of the century (year divided by 100, truncated to an integer)  -  19 for the 20th Century

				output += this.getFullYear().toString().substring(0, 2);
				break;

			case '%y':  // %y  -  Two digit representation of the year  -  Example: 09 for 2009, 79 for 1979

				output += this.getFullYear().toString().substring(2, 4);
				break;

			case '%Y':  // %Y  -  Four digit representation for the year  -  Example: 2038

				output += this.getFullYear().toString();
				break;

			// Time
			case '%H':  // %H  -  Two digit representation of the hour in 24-hour format  -  00 through 23

				output += this.getHours().toString().lpad(0, 2);
				break;

			case '%k':  // %k  -  Two digit representation of the hour in 24-hour format, with a space preceding single digits  -  0 through 23

				output += this.getHours().toString().lpad(' ', 2);
				break;

			case '%I':  // %I  -  Two digit representation of the hour in 12-hour format  -  01 through 12

				var hours = this.getHours() % 12;
				output += (hours ? hours : 12).toString().lpad(0, 2);
				break;

			case '%l':  // %l (lower-case 'L')  -  Hour in 12-hour format, with a space preceding single digits  -  1 through 12

				var hours = this.getHours() % 12;
				output += (hours ? hours : 12).toString().lpad(' ', 2);
				break;

			case '%M':  // %M  -  Two digit representation of the minute  -  00 through 59

				output += this.getMinutes().toString().lpad(0, 2);
				break;

			case '%p':  // %p  -  UPPER-CASE 'AM' or 'PM' based on the given time  -  Example: AM for 00:31, PM for 22:23

				output += this.getHours() < 12 ? 'AM' : 'PM';
				break;

			case '%P':  // %P  -  lower-case 'am' or 'pm' based on the given time  -  Example: am for 00:31, pm for 22:23

				output += this.getHours() < 12 ? 'am' : 'pm';
				break;

			case '%r':  // %r  -  Same as "%I:%M:%S %p"  -  Example: 09:34:17 PM for 21:34:17

				format = '%I:%M:%S %p' + format;  // Re-queue
				break;

			case '%R':  // %R  -  Same as "%H:%M"  -  Example: 00:35 for 12:35 AM, 16:44 for 4:44 PM

				format = '%H:%M' + format;  // Re-queue
				break;

			case '%S':  // %S  -  Two digit representation of the second  -  00 through 59

				output += this.getSeconds().toString().lpad(0, 2);
				break;

			case '%T':  // %T  -  Same as "%H:%M:%S"  -  Example: 21:34:17 for 09:34:17 PM

				format = '%H:%M%S' + format;  // Re-queue
				break;

			case '%z':  // %z  -  The time zone offset  -  Example: -0500 for US Eastern Time

				var TZ = - this.getTimezoneOffset();
				output += (TZ < 0 ? '-' : '+') + Math.abs(TZ / 60).toString().lpad(0, 2) + Math.abs(TZ % 60).toString().lpad(0, 2);
				break;

			// Time and Date Stamps
			case '%D':  // %D  -  Same as "%m/%d/%y"  -  Example: 02/05/09 for February 5, 2009

				format = '%m/%d/%y' + format;  // Re-queue
				break;

			case '%F':  // %F  -  Same as "%Y-%m-%d" (commonly used in database datestamps)  -  Example: 2009-02-05 for February 5, 2009

				format = '%Y-%m-%d' + format;  // Re-queue
				break;

			case '%s':  // %s  -  Unix Epoch Time timestamp (same as the time() function)  -  Example: 305815200 for September 10, 1979 08:40:00 AM

				output += this.getTime().toString().substring(0, -3);
				break;

			// Miscellaneous
			case '%n':  // %n  -  A newline character ("\n")

				output += "\n";
				break;

			case '%t':  // %t  -  A Tab character ("\t")

				output += "\t";
				break;

			case '%%':  // %%  -  A literal percentage character ("%")

				output += '%';
				break;

			// Fallback
			default:

				output += digit;
		}
	}

	// Return
	return output;
}